/**
 * OrbPostMachinesWithTraitsPart1VisionENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbPostMachinesWithTraitsPart1VisionENPostPage
 */

import { useOrbPostMachinesWithTraitsPart1VisionENPostPageLogic } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionENPostPageLogic';
import type { OrbPostMachinesWithTraitsPart1VisionENPostPageConfig } from '@/hooks/traits/useOrbPostMachinesWithTraitsPart1VisionENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbPostMachinesWithTraitsPart1VisionENPostView as OrbPostMachinesWithTraitsPart1VisionENPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { OrbPostMachinesWithTraitsPart1VisionENPostFooterView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionENPostFooterView';
import { OrbPostMachinesWithTraitsPart1VisionENPostHeaderView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionENPostHeaderView';
import { OrbPostMachinesWithTraitsPart1VisionENPostView } from '@/components/traits/OrbPostMachinesWithTraitsPart1VisionENPostView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbPostMachinesWithTraitsPart1VisionENPostPageViewProps {
  config?: Partial<OrbPostMachinesWithTraitsPart1VisionENPostPageConfig>;
}

export function OrbPostMachinesWithTraitsPart1VisionENPostPageView({ config: propsConfig }: OrbPostMachinesWithTraitsPart1VisionENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbPostMachinesWithTraitsPart1VisionENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbPostMachinesWithTraitsPart1VisionENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbPostMachinesWithTraitsPart1VisionEN" trait="OrbPostMachinesWithTraitsPart1VisionENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbPostMachinesWithTraitsPart1VisionENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbPostMachinesWithTraitsPart1VisionENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box bg="transparent" fullWidth={true} paddingY="xl"><Container maxWidth="xl" padding="lg" size="xl"><OrbPostMachinesWithTraitsPart1VisionENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><OrbPostMachinesWithTraitsPart1VisionENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbPostMachinesWithTraitsPart1VisionENPostPageView;
